class SizeGuideChart extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.unitButtons = this.querySelectorAll('[data-set-unit]');
    this.switchButton = this.querySelector('[data-toggle-unit]');

    this.unitButtons.forEach((button) => {
      button.addEventListener('click', () => this.setUnit(button.dataset.setUnit));
    });

    if (this.switchButton) {
      this.switchButton.addEventListener('click', () => {
        const next = this.dataset.unit === 'cm' ? 'inches' : 'cm';
        this.setUnit(next);
      });
    }
  }

  setUnit(unit) {
    if (unit !== 'cm' && unit !== 'inches') return;

    this.dataset.unit = unit;
    this.unitButtons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.setUnit === unit);
    });

    if (this.switchButton) {
      this.switchButton.setAttribute('aria-checked', unit === 'inches' ? 'true' : 'false');
    }
  }
}

if (!customElements.get('size-guide-chart')) {
  customElements.define('size-guide-chart', SizeGuideChart);
}

/**
 * Open size guide from footer (and any) links pointing to #size-guide.
 */
(function () {
  if (window.__peggellSizeGuideLinksBound) return;
  window.__peggellSizeGuideLinksBound = true;

  function findSizeGuideModal() {
    return (
      document.getElementById('SizeGuideModal') ||
      document.querySelector('modal-dialog.size-guide-modal')
    );
  }

  function isSizeGuideHref(href) {
    if (!href) return false;
    try {
      const url = new URL(href, window.location.origin);
      return url.hash === '#size-guide';
    } catch (e) {
      return /#size-guide$/i.test(href);
    }
  }

  function openSizeGuide(opener) {
    const modal = findSizeGuideModal();
    if (!modal || typeof modal.show !== 'function') return false;
    modal.show(opener || null);
    return true;
  }

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href*="#size-guide"]');
      if (!link || !isSizeGuideHref(link.getAttribute('href'))) return;

      event.preventDefault();
      openSizeGuide(link);
    },
    true
  );

  // Deep link / refresh with #size-guide
  document.addEventListener('DOMContentLoaded', () => {
    if (window.location.hash === '#size-guide') {
      openSizeGuide(null);
    }
  });
})();
